import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';

@Component({
  selector: 'app-shortcut-dialog',
  templateUrl: './shortcut-dialog.component.html',
  styleUrls: ['./shortcut-dialog.component.css']
})
export class ShortcutDialogComponent implements OnInit, OnDestroy {
  meetingStarted: any = true;
  meetingStartedSubscription!: Subscription;

  constructor(public sideNav : SideNavServiceService, public dialog : MatDialog) { }

  ngOnInit(): void {
    this.meetingStartedSubscription = this.sideNav.meetingStarted.subscribe((res: any) => {
      this.meetingStarted = res;
    })
  }

  ngOnDestroy(): void {
    if (this.meetingStartedSubscription) {
      this.meetingStartedSubscription.unsubscribe();
    }
  }

  closeTrigger(){
    let openShortCut = <HTMLElement>document.getElementById('open-short-cut');
    openShortCut.removeAttribute('disabled')
    this.sideNav.pinShortCutDialog(false)
  }

  pinDialog(){
    this.sideNav.pinShortCutDialog(true)
    this.dialog.closeAll()
  }

  removePinDialog(){
    this.sideNav.pinShortCutDialog(false)
    let openShortCut = <HTMLElement>document.getElementById('open-short-cut');
    openShortCut.removeAttribute('disabled')
    document.getElementById('open-short-cut')?.click()
  }

}
